import {
  TokenResponse,
  googleLogout
} from "@react-oauth/google";
import "./registration-verfication.scss";
import { useEffect, useState } from "react";
import axios from "axios";
import Form from "react-bootstrap/Form";
import { Container } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../hooks/typed-hooks";
import { userRegistrationSelector } from "../../../redux/reducers/user-registration/userRegistrationSlice";
import { toast } from "react-toastify";
import { createNewUserSession, userSessionStateSelector } from "../../../redux/reducers/user-session/userSessionSlice";

const RegistrationVerification: React.FC = () => {

  let apiUrl = process.env.REACT_APP_API_URL || "https://trowelwa01.azurewebsites.net/api/";
  // Ensure apiUrl ends with a slash
  if (!apiUrl.endsWith('/')) {
    apiUrl += '/';
  }
  // let apiUrl = process.env.REACT_APP_API_URL;
  // if(!apiUrl){ // Fallback value for prod environment
  //   apiUrl = "https://trowelwa01.azurewebsites.net/";
  // }

  //navigation
  const navigate = useNavigate();
  const location = useLocation();

  //store
  const selectUserInfo = useAppSelector(userRegistrationSelector);
  const selectUserSessionInfo = useAppSelector(userSessionStateSelector);
  const dispatch = useAppDispatch();

  type UserType = Omit<
    TokenResponse,
    "error" | "error_description" | "error_uri"
  >;
  const [user, setUser] = useState<UserType | null>(null);
  const [profile, setProfile] = useState<any>([]);
  const [isVerificationSuccess, setIsVerificationSuccess] =
    useState<boolean>(false);
  const [verficationStatusMessage, setVerficationStatusMessage] =
    useState<string>("");
  const [isVerificationInProgress, setIsVerificationInProgress] =
    useState<boolean>(true);

  const responseMessage = (response: any) => {
    console.log("Response data : ", response);
  };
  const errorMessage = () => {
    console.log("Error");
  };

  useEffect(() => {
    setIsVerificationInProgress(true);
  }, []);

  useEffect(() => {
    if (user) {
      axios
        .get(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`,
          {
            headers: {
              Authorization: `Bearer ${user.access_token}`,
              Accept: "application/json",
            },
          }
        )
        .then((res) => {
          setProfile(res.data);
          /*email: "trowelagent@gmail.com"
family_name: "ai"
given_name: "Trowel"
id: "101750992935389276550"
name: "Trowel ai"
picture: "https://lh3.googleusercontent.com/a/ACg8ocK0WGiMTnX-TV3Fu5r6VIo-erHptBFlhvlVH7vXNpxKQMco6w=s96-c"
verified_email: true */
        })
        .catch((err) => console.log(err));
    }
  }, [user]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const verificationToken = searchParams.get("token");
    console.log("Token value", verificationToken);

    let signupVerficationUrl: string = `${apiUrl}auth/verify`;
    //"https://trowelwa01.azurewebsites.net/auth/verify";

    axios
      .post(signupVerficationUrl, { token: verificationToken })
      .then((response: any) => {
        console.log("Response after verification", response);

        let { status, message } = response.data;
        setIsVerificationSuccess(status);
        setVerficationStatusMessage(message);
        toast.success(message);
        setIsVerificationInProgress(false);
      })
      .catch((err) => {
        console.log("Error while verifing user registration");
        setIsVerificationInProgress(false);
      });
  }, [location.search]);

  const logOut = () => {
    googleLogout();
    setProfile(null);
  };

  return (
    <Container>
      <section className="registration-verification-wrapper">
        <div className="linear-gradient-circle"></div>
        <div className="linear-gradient-circle botton-gradient"></div>

        <div className="registration-verification-overlay">
          <div className="trowel-logo">
            <span className="trwl-logo__icon"></span>
            <span className="trwl-logo__text">TROWEL.AI</span>
          </div>
          {isVerificationInProgress && (
            <h3>Verification in progress.... please wait...</h3>
          )}

          {!isVerificationInProgress && (
            <div className="reg-completed-info">
              <div className="reg-completed-info__image"></div>

              {isVerificationSuccess && (
                <>
                  <div className="reg-completed-info__main-text-normal">
                    Your registration is completed !
                  </div>
                  <div className="reg-completed-info__sub-text-bold">
                    Welcome aboard!
                  </div>
                  <div className="reg-completed-info__sub-text">
                    Congratulation! you're now part of our community.
                  </div>

                  <div
                    className="reg-completed-info__resend-notification"
                    onClick={() => {
                      navigate("/login");
                    }}
                  >
                    Login
                  </div>
                </>
              )}

              {!isVerificationSuccess && (
                <>
                  <div className="reg-completed-info__main-text-normal __failed">
                    Your registration verfication failed !
                  </div>
                  <div className="reg-completed-info__sub-text-bold">
                    {verficationStatusMessage}
                  </div>
                  <div className="reg-completed-info__sub-text">
                    Please try again later
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      </section>
    </Container>
  );
};

export default RegistrationVerification;
